export default __webpack_public_path__ + "static/media/app-heatmap-dark.fb9131b8.png";